/** One of the loan's properties: only what the steps use so far (the Property step will add its fields). */
export interface PropertyForm {
    /** undefined for a property that hasn't been saved yet. */
    id: number | undefined;
    /** Its place on the loan (1, 2, ...), shown as ".01", ".02", ... after the BFI #. */
    bfiNumberSuffix: number;
    commitment: number | undefined;
    originationFee: number | undefined;
}

/** EditStdLoanModal always shows at least one property, so a loan without any gets this one. */
export const emptyPropertyForm: PropertyForm = {
    id: undefined,
    bfiNumberSuffix: 1,
    commitment: undefined,
    originationFee: undefined,
};
